export const client = {
  state: {
    clientController: null
  },
  mutations: {
    receivedClientController (state, controller) {
      state.clientController = controller
    }
  },
  actions: {
    fetchOrganizationCode ({ state: { clientController } }) {
      return clientController.fetchOrganizationCode()
    },

    fetchSystemCode ({ state: { clientController } }) {
      return Promise.resolve(clientController.system)
    },

    fetchCredentials ({ state: { clientController } }) {
      return clientController.fetchCredentials()
    },

    uploadAuthorization ({ state: { clientController } }, { organizationId, token }) {
      return clientController.uploadAuthorization(organizationId, token)
    },

    clearAuthorization ({ state: { clientController } }) {
      return clientController.clearAuthorization()
    },

    fetchClientAgent ({ state: { clientController } }) {
      return clientController.fetchClientAgent()
    },

    fetchClientAgents ({ state: { clientController }, getters: { settings } }) {
      return clientController.fetchAgents(settings.access_token)
    },

    fetchOnboardingParams ({ state: { clientController } }) {
      return clientController.fetchOnboardingParams()
    },

    fetchOnboardingPortalParams ({ state: { clientController } }) {
      return clientController.fetchOnboardingPortalParams()
    },

    fetchPortalSettingsUrl ({ state: { clientController } }) {
      return clientController.fetchPortalSettingsUrl()
    },

    resizeApplet ({ state: { clientController } }, { height }) {
      if (clientController) {
        clientController.resizeApplet({ height })
      }
    },

    async initializeClient ({ dispatch, commit }, clientControllerType) {
      const clientController = await clientControllerType.initialize()
      clientController.onAddNote = () => dispatch('willAddNote')
      clientController.onUpdate = () => dispatch('fetchLastTranslation')
      commit('receivedClientController', clientController)
    },

    async fetchPayloadForFirstMessage ({ state: { clientController }, dispatch, commit, getters }) {
      const { agent, startAutomatically } = getters
      const message = await clientController.getThreadForMessagePayload()
      return {
        mode: 'mt',
        agent,
        message,
        canTranslate: startAutomatically
      }
    },

    async handleUnauthorizedAgent ({ state: { clientController } }) {
      console.log('Handling unauthorized agent in client')
      await clientController.closeApplet()
    }

  },
  getters: {
    clientController: ({ clientController }) => clientController
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/client.js